import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-common-dialog',
  templateUrl: './common-dialog.component.html',
  styleUrls: ['./common-dialog.component.scss']
})
export class CommonDialogComponent implements OnInit {

  /*
    buttons: [
      {
        name: 'ok',
        text: 'אישור',
        color: 'accent' 

      }
    ]
    
  */

  buttons:any[] = []; // {}
  message = '';

  constructor(private router: Router,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<CommonDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any) { 
      
        this.buttons = data && data.buttons || [];
        this.message = data && data.message || '';
    }

  ngOnInit(): void {
   
  }

  onClick(btn){
    
    this.dialogRef.close(btn.name);
  }
 

}
